<template>
    <v-container fluid class="text-xs-center"> 
        <v-layout row wrap>
            <span class="field-title">{{$t('labels.binomial')}}</span>
            <span class="field-value italic" style="font-weight: 600;">{{speciesSingle.genus}} {{speciesSingle.species}}</span>
            <span class="field-title">{{$t('labels.genus')}}</span>
            <span class="field-value italic">{{speciesSingle.genus}}</span><br>
            <span class="field-title">{{$t('labels.family')}}</span>
            <span class="field-value">{{speciesSingle.family}}</span><br>
            <span class="field-title" v-if="speciesSingle.suborder">{{$t('labels.suborder')}}</span>
            <span class="field-value" v-if="speciesSingle.suborder">{{speciesSingle.suborder}}</span><br v-if="speciesSingle.suborder">
            <span class="field-title">{{$t('labels.order')}}</span>
            <span class="field-value">{{speciesSingle.order}}</span><br>
            <br>
            <span class="field-title">{{$t('views.Researches')}}</span>
            <span class="field-value">
                <span style="font-style:italic;" v-if="speciesSingle.researchIds.length==0">{{$t('labels.noLinkedResearch')}}</span>
                <research-card v-for="researchId in speciesSingle.researchIds" :key="researchId" :researchId="researchId"></research-card>
            </span><br>
        </v-layout>
        <v-dialog
            v-model="showDeletionDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{$t('labels.confirmDeletion')}}
                </v-card-title>
                <v-card-text>
                    {{$t('labels.confirmSpeciesQuestion')}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showDeletionDialog = false"
                >
                    No
                </v-btn>
                <v-btn
                    color="red"
                    style="color:white"
                    text
                    @click="deleteSpecies();showDeletionDialog = false"
                >
                    {{$t('labels.yesDelete')}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--<v-btn
            dark
            absolute
            bottom
            right
            fab
            style="bottom:20px;"
            @click="$router.push({name: 'speciesEdit', params:{speciesId:speciesSingle.id}});"
            > <v-icon style="font-size:40px;padding-top:5px;">edit</v-icon>
        </v-btn>-->
        <div class="bottom-bar-holder">
            <div class="bottom-bar">
                <v-layout
                    justify-center
                    style="padding:0"
                >
                    <v-btn
                        color="white"
                        style="background:rgb(244, 67, 54);font-size:20px;float:right;"
                        flat
                        @click.native="showDeletionDialog=true"
                    >
                        <v-icon>delete</v-icon>&nbsp;&nbsp;{{$t('labels.delete')}}
                    </v-btn>
                </v-layout>
            </div>
        </div>
        <v-snackbar v-model="showDeletedToast">
            {{$t('labels.speciesDeleted')}}!
        </v-snackbar>
    </v-container>
</template>

<script>
import ResearchCard from '../partial/ResearchCard.vue';
const axios = require('axios').default;
export default {
    name: 'SpeciesSingle',
    components: {
        ResearchCard
    },
    data: function(){
        return{
            showDeletionDialog: false,
            showDeletedToast: false,
            searchedText: "",
            speciesSingle:{
                researchIds:[]
            }
        };
    },
    mounted: function(){
        let vm = this;
        vm.getSpeciesSingle();
    },
    methods:{
        getSpeciesSingle(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "species/getResource.php?speciesId="+vm.$route.params.speciesId,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.speciesSingle = response.data.resource;
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        },
        deleteSpecies(){
            let vm = this;
            axios({
                method: "DELETE",
                url: vm.$API_BASE_URL + "species/delete.php",
                data: {
                    "species":[vm.$route.params.speciesId]
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.showDeletedToast = true;
                    vm.$router.push({name: 'species'});
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        }
    }
}
</script>
